import { FeatureDto } from "./FeatureDto";
import { InfoWarning } from "./InfoWarning";
import { ProductStatus } from "./ProductStatus";

export interface DeviceStatus {
	deviceState: DeviceState;
	deviceCategory: DeviceCategory;
	dateUpdated: string;
	deviceName: string;
	deviceLocalization: string;
	deviceServer: string;
	appInstanceName: string;
	isSelfInsurance: boolean;
	hasSelfInsInstance: boolean;
	appUrls: string[];
	apiUrl: string;
	customerId: number;
	infoWarningNotificationEmailEnabled: boolean;
	infoWarningNotificationEmailRecipients: string | null;
	infoWarnings: InfoWarning[];
	features: FeatureDto[];
	productStatus: ProductStatus;
}

export enum DeviceState {
	Unknown = 0,
	Connected = 1,
	Disconnected = 2,
	Offline = 3,
}

export enum DeviceCategory {
	Client = 0,
	Internal = 1,
	Demo = 2,
}
